var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "fit-content", scrollable: "" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function(ref) {
              var on = ref.on
              return [
                _c(
                  "v-btn",
                  _vm._g(
                    {
                      staticClass: "text-none my-0 mx-1 activator-btn",
                      attrs: { flat: "", small: "", color: "blue lighten-1" }
                    },
                    on
                  ),
                  [
                    _vm._t("default", [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("tag")]),
                      _vm._v("\n\t\t\t\tSuifa OF\n\t\t\t")
                    ])
                  ],
                  2
                )
              ]
            }
          }
        ],
        null,
        true
      ),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("div", {
        directives: [
          {
            name: "shortkey",
            rawName: "v-shortkey",
            value: ["esc"],
            expression: "['esc']"
          }
        ],
        on: {
          shortkey: function($event) {
            _vm.dialog = false
          }
        }
      }),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "background darken-1" },
        [
          _c(
            "v-card-title",
            { staticClass: "py-1" },
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("\n\t\t\t\tSuifa OF\n\t\t\t")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mr-3",
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function($event) {
                      _vm.dialog = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-2" },
            [
              _c("SuifaOF", {
                on: {
                  "assets-selected": function($event) {
                    _vm.$emit("suifa-asset-selected", $event)
                    _vm.dialog = false
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08472f10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08472f10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/tools/suifa_of/suifa_of_dialog.vue
// module id = null
// module chunks = 